import { TreeDndTree } from '@/components/tree-dnd/tree-dnd-node';
import { useTreeDndUiStore } from '@/components/tree-dnd/tree-dnd-ui-store';
import { AudienceCreateFilterEmptyState } from '@/components/audiences/audience-create-filter-empty-state';
import { cn } from '@/lib/utils';

interface AudienceCreateFilterSectionProps {
  className?: string;
}

export function AudienceCreateFilterSection({
  className,
}: AudienceCreateFilterSectionProps) {
  const requestAddSheet = useTreeDndUiStore((state) => state.requestAddSheet);

  return (
    <div className={cn('min-w-0', className)}>
      <TreeDndTree
        emptyFallback={
          <AudienceCreateFilterEmptyState
            onAddFirstFilter={() => requestAddSheet([])}
          />
        }
      />
    </div>
  );
}
